import { useEffect, useRef, useState } from "react";
import ormOffersService from "../hooks/api/offers";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { cleanHtmlText, convertCurrency, stripHTML } from "../utils/formater";
import ORMfunctions from "../hooks/app/general";
import Slider from "react-slick";

import SearchModal from "../components/modals/SearchmodalV2";

import { setOfferSelected, setSelectedVehicle } from "../store/orm/userSession";

interface SlickSlider {
  slickNext(): void;
  slickPause(): void;
  slickPlay(): void;
  slickPrev(): void;
  slickGoTo(slideNumber: number, dontAnimate?: boolean): void;
}

function Offers(props: any) {
  const offers = useSelector((state: RootState) => state.offers.offers);
  const dispatch = useDispatch();

  let sliderRef = useRef<SlickSlider>(null);

  const SliderCustom: any = Slider;

  const [showModal, setShowModal] = useState(false);
  const [enabledstations, setEnabledstations] = useState<string[] | undefined>(
    undefined,
  );

  const [oldSlide, setOldSlide] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlide2, setActiveSlide2] = useState(0);

  const [claims, setClaims] = useState<any>([]);

  function generateClaim() {
    return props.claims[Math.floor(Math.random() * props.claims.length)];
  }

  useEffect(() => {
    ormOffersService.fetchOffers();
  }, []);

  useEffect(() => {
    for (let index = 0; index < offers.length; index++) {
      const element = generateClaim();
      setClaims((claims: any) => [...claims, element]);
    }
  }, [offers]);

  const next = () => {
    const slider = sliderRef as unknown as SlickSlider;
    slider.slickNext();
  };
  const previous = () => {
    const slider = sliderRef as unknown as SlickSlider;
    slider.slickPrev();
  };

  function setCar(offer: any) {
    setEnabledstations(offer.station_ids);

    dispatch(setOfferSelected(offer));

    dispatch(
      setSelectedVehicle({
        vehicleId: offer.vehicle_group_id,
        categories: offer.vehicle_group_ids,
      }),
    );

    setShowModal(true);
  }

  function clearOffer() {
    dispatch(setOfferSelected(null));
    dispatch(setSelectedVehicle({ vehicleId: null, categories: null }));
    setShowModal(false);
  }

  const settings = {
    dots: true,
    arrows: false,
    fade: true,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    lazyLoad: true,
    beforeChange: (current: any, next: any) => {
      setOldSlide(current);
      setActiveSlide(next);
    },
    afterChange: (current: any) => setActiveSlide2(current),
  };

  return (
    <div className="orm-container orm-xs-no-gutter">
      <div className="orm-row">
        <div className="orm-col-xs-12">
          <div className="orm-offers">
            <SliderCustom
              className="orm-offers-slider"
              {...settings}
              ref={(slider: any) => {
                sliderRef = slider;
              }}
            >
              {offers.map((offer: any, index: number) => (
                <div className="orm-offers-wrapper">
                  <div className="orm-offers-imageWrapper">
                    <div
                      className="slick-arrow slick-prev"
                      onClick={previous}
                    ></div>
                    <div
                      className="slick-arrow slick-next"
                      onClick={next}
                    ></div>
                    <img
                      className="orm-offers-image"
                      src={offer.image_url}
                      alt={`${offer.headline}-Bild`}
                    />
                  </div>

                  <div className="orm-offers-content">
                    <div className="orm-offers-teasline">
                      {ORMfunctions.i18n("cargroup/offer") || "Angebot"}
                    </div>
                    <div
                      className="orm-offers-headline"
                      dangerouslySetInnerHTML={{
                        __html: stripHTML(offer.headline) || offer.headline,
                      }}
                    ></div>
                    <div
                      className="orm-offers-text"
                      dangerouslySetInnerHTML={{
                        __html:
                          cleanHtmlText(offer.description) || offer.description,
                      }}
                    ></div>

                    <div className="orm-offers-pricing">
                      <div className="orm-carprice">
                        <div className="orm-price__txt__surtitle">
                          {offer.price_text}
                        </div>
                        <div className="orm-price__txt">
                          {convertCurrency(offer.price)}
                        </div>
                      </div>
                      <div>
                        <div className="orm-offers-teaser">{claims[index]}</div>
                        <div
                          className="orm-offers-sidetext"
                          dangerouslySetInnerHTML={{
                            __html: offer.description2 || offer.description2,
                          }}
                        ></div>
                      </div>
                    </div>

                    <div className="orm-offers-btnwrapper">
                      <button
                        className="orm-button__cta orm-button__cta--offer wide"
                        onClick={() => setCar(offer)}
                        tabIndex={activeSlide == index ? 1 : -0}
                      >
                        {ORMfunctions.i18n("cargroup/select_offer") ||
                          "Angebot sichern"}
                        <i className="orm-button__cta--offer-icon far fa-stars"></i>
                      </button>
                    </div>
                    <div
                      className="orm-offers-legaltext"
                      dangerouslySetInnerHTML={{
                        __html: offer.description3 || offer.description3,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </SliderCustom>

            {showModal && (
              <SearchModal
                enabledstations={enabledstations}
                close={clearOffer}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Offers;
